import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIsFetching } from 'react-query';

import { setLoading } from '../../../store/slices/UI';
import useMeloLocation from './useMeloLocation';

const useLoading = () => {
  const dispatch = useDispatch();

  const isFetchingGlobal = useIsFetching();

  const { avoidGlobalLoading } = useMeloLocation();

  useEffect(() => {
    if (!avoidGlobalLoading) {
      if (isFetchingGlobal) {
        dispatch(setLoading(true));
      } else {
        dispatch(setLoading(false));
      }
    }
  }, [avoidGlobalLoading, dispatch, isFetchingGlobal]);
};

export default useLoading;
